import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR } from 'types/wellGuardian';

import { getKickOffSectionKey, getWirCreatedSectionKey } from './getSectionData';

export const getWirCreatedReactiveScopeData = (wir: WIR | null, countrySelect: string) => {
  const wirStep = getWirCreatedSectionKey(countrySelect);

  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : wirStep;
  const organiseKickOffMeeting = wir?.phases?.[phase]?.sections?.organiseKickOffMeeting;
  const initialRequestInformation = wir?.phases?.[phase]?.sections?.initialRequestInformation;

  return {
    phase,
    organiseKickOffMeeting,
    initialRequestInformation,
  };
};

export const getWirCGOrganiseKOM = (wir: WIR | null, countrySelect: string) => {
  const wirStep =
    countrySelect === CountryData.congo
      ? getKickOffSectionKey(countrySelect)
      : getWirCreatedSectionKey(countrySelect);

  const phase = getIsUnplannedReactiveScope(wir)
    ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
    : wirStep;
  const organiseKickOffMeeting = wir?.phases?.[phase]?.sections?.organiseKickOffMeeting;

  return {
    phase,
    organiseKickOffMeeting,
  };
};
